<script setup lang="ts">
import { useClampable } from "@/composables/useClampable";
import { useAssistantSettingsStore } from "@/stores/assistantSettingsStore";

const { lineClamp = undefined, expandable = true } = defineProps<{
  lineClamp?: number;
  expandable?: boolean;
}>();

const { assistantSettings } = useAssistantSettingsStore();

const clampable = ref<HTMLElement | null>(null);

const { isExpanded, isExpandable, expand } = useClampable(clampable, lineClamp);
</script>

<template>
  <div v-if="assistantSettings.text.short_disclaimer" class="chat-disclaimer">
    <div ref="clampable" class="text">
      {{ assistantSettings.text.short_disclaimer }}
    </div>
    <div
      v-if="expandable && isExpandable && !isExpanded"
      class="more"
      @click="expand"
    >
      Lees verder
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chat-disclaimer {
  font-size: 0.8em;
  text-align: center;
}

.text {
  opacity: 0.5;
}

.more {
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: var(--chat-input-focus-color);
  }
}
</style>
